import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Loader from "../../shared/loader";

const Invoices = () => {
  const [searchValue, setSearchValue] = useState("");
  const [partyData, setPartyData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getInvoices = () => {
    axios.post(API_URL.INVOICE_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          res.data.data.data.map(
            (item) => (item.date = moment(item.date).format("DD/MM/YYYY"))
          );
          setPartyData(res.data.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          
        });
      }
    );
  };

  const deleteInvoice = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Invoice No - " + row.invoice_no,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.INVOICE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = partyData.filter((r) => r.id != row.id);
              setPartyData(newData);
              toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getInvoices();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-md-6">
            <h1>Invoices <small className="me-2">({partyData.length})</small></h1>
        </div>
        <div className="col-md-6">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{width: 300}}>
              <input
                type="text"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                className="form-control"
                placeholder="Search"
              />
            </div>
            <Link to={"/sales/invoices/add"} className="btn btn-primary">
                <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add Invoice
            </Link>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Invoice No</th>
                        <th>Name</th>
                        <th>Invoice Date</th>
                        <th>Amount</th>
                        <th>Qty</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {partyData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{row.id}</td>
                            <td>{row.prefix}/{row.invoice_no}</td>
                            <td>{row.party ? row.party.name : ""}</td>
                            <td>{row.date}</td>
                            <td>{row.total_amount}</td>
                            <td>{row.total_qty}</td>
                            <td>{row.status}</td>
                            <td>
                            {row.status == 'Completed' && (
                              <Link
                                to={"/invoice/view/" + row.id}
                                className="btn btn-sm btn-success mr-2 text-white"
                              >
                                <i className="fa fa-print me-1"></i> Print
                              </Link> )}
                              <Link
                                to={"/sales/invoices/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteInvoice(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invoices;
